import React                from "react";
import Box                  from "@mui/material/Box";
import Button               from "@mui/material/Button";
import Typography           from "@mui/material/Typography";
import TextField            from "@mui/material/TextField";
import MenuItem             from '@mui/material/MenuItem';
import { IGradeOption }     from "hooks/useProgramCatalog";
import {
    CREATE_CLASS_FORM_GRADE,
    CREATE_CLASS_FORM_NAME,
    CREATE_CLASS_FORM_SUBMIT,
}                           from "config/config";

// Body of the "Create class" step (name + grade + submit). Pure client-side form: no
// HTTP here — the class is created in one request when Review is confirmed (ClassFlow).
// Draft state is local so typing rerenders only this form, never the host dialog
// (review #340 item 5); every change is mirrored to the host's draft ref via onDraft
// so Back/forward never loses input.
export default function CreateClassFields({
    initialName,
    initialGrade,
    grades,
    onDraft,
    onSubmit,
}: {
    initialName: string;
    initialGrade: string;
    grades: IGradeOption[];   // from the /programs catalog; value sent is the grade id
    onDraft: (name: string, grade: string) => void;
    onSubmit: (name: string, grade: string) => void;
}) {
    const [name, setName] = React.useState(initialName);
    const [grade, setGrade] = React.useState(initialGrade);
    const [error, setError] = React.useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!name.trim() || !grade) {
            setError("Please fill in all fields.");
            return;
        }
        onSubmit(name.trim(), grade);
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}
        >
            <TextField
                fullWidth
                label={CREATE_CLASS_FORM_NAME}
                required
                value={name}
                onChange={(e) => {
                    setName(e.target.value);
                    onDraft(e.target.value, grade);
                    if (error) setError('');
                }}
            />
            <TextField
                select
                required
                fullWidth
                label={CREATE_CLASS_FORM_GRADE}
                value={grade}
                onChange={(e) => {
                    setGrade(e.target.value);
                    onDraft(name, e.target.value);
                    if (error) setError('');
                }}
            >
                {grades.map((g) => (
                    <MenuItem key={g.id} value={g.id}>{g.label}</MenuItem>
                ))}
            </TextField>
            <Button
                variant='contained'
                fullWidth
                type='submit'
                color={error ? 'error' : 'primary'}
                sx={{ boxShadow: 'none' }}
            >
                {CREATE_CLASS_FORM_SUBMIT}
            </Button>
            {error &&
                <Typography align="center" color="error">{error}</Typography>
            }
        </Box>
    );
}
